"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BiofertilizerFacility = void 0;
var Card_1 = require("../Card");
var CardName_1 = require("../../CardName");
var SelectSpace_1 = require("../../inputs/SelectSpace");
var Resources_1 = require("../../Resources");
var ResourceType_1 = require("../../ResourceType");
var SpaceBonus_1 = require("../../SpaceBonus");
var SpaceType_1 = require("../../SpaceType");
var TileType_1 = require("../../TileType");
var CardType_1 = require("../CardType");
var Tags_1 = require("../Tags");
var AddResourcesToCard_1 = require("../../deferredActions/AddResourcesToCard");
var CardRequirements_1 = require("../CardRequirements");
var CardRenderer_1 = require("../render/CardRenderer");
var Units_1 = require("../../Units");
var BiofertilizerFacility = (function (_super) {
    __extends(BiofertilizerFacility, _super);
    function BiofertilizerFacility() {
        return _super.call(this, {
            cardType: CardType_1.CardType.AUTOMATED,
            name: CardName_1.CardName.BIOFERTILIZER_FACILITY,
            tags: [Tags_1.Tags.MICROBE, Tags_1.Tags.BUILDING],
            cost: 12,
            productionBox: Units_1.Units.of({ plants: 1 }),
            requirements: CardRequirements_1.CardRequirements.builder(function (b) { return b.tag(Tags_1.Tags.SCIENCE); }),
            metadata: {
                description: 'Requires 1 science tag. Increase your plant production 1 step. ' +
                    'Add up to 2 microbes to any card. ' +
                    'Place this tile which grants an ADJACENCY BONUS of 1 plant and 1 microbe.',
                cardNumber: 'A02',
                renderData: CardRenderer_1.CardRenderer.builder(function (b) {
                    b.production(function (pb) { return pb.plants(1); });
                    b.microbes(2);
                    b.br;
                    b.tile(TileType_1.TileType.BIOFERTILIZER_FACILITY, false, true);
                }),
            },
        }) || this;
    }
    BiofertilizerFacility.prototype.play = function (player) {
        var _this = this;
        player.addProduction(Resources_1.Resources.PLANTS, 1);
        player.game.defer(new AddResourcesToCard_1.AddResourcesToCard(player, ResourceType_1.ResourceType.MICROBE, { count: 2 }));
        return new SelectSpace_1.SelectSpace('Select space for Biofertilizer Facility tile', player.game.board.getAvailableSpacesOnLand(player), function (space) {
            player.game.addTile(player, SpaceType_1.SpaceType.LAND, space, {
                tileType: TileType_1.TileType.BIOFERTILIZER_FACILITY,
                card: _this.name,
            });
            space.adjacency = {
                bonus: [SpaceBonus_1.SpaceBonus.PLANT, SpaceBonus_1.SpaceBonus.MICROBE],
            };
            return undefined;
        });
    };
    return BiofertilizerFacility;
}(Card_1.Card));
exports.BiofertilizerFacility = BiofertilizerFacility;
